import { render, staticRenderFns } from "./PictureBtn.vue?vue&type=template&id=009cd9fd&scoped=true&"
import script from "./PictureBtn.vue?vue&type=script&lang=js&"
export * from "./PictureBtn.vue?vue&type=script&lang=js&"
import style0 from "./PictureBtn.vue?vue&type=style&index=0&id=009cd9fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009cd9fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VImg,VRow})
